<template>
  <v-card flat>
    <v-card-title>{{ assembled ? "Assembled " : "" }}Prices</v-card-title>
    <v-card-text>
      <v-flex xs12 v-for="currency in currencies" :key="currency.id">
        <price-form
          :productId="product.id"
          :catalogId="catalogId"
          :productPrice="getPriceObject(currency)"
          :currency="currency"
          :assembled=assembled
        ></price-form>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import PriceForm from "./PriceForm";

export default {
  components: {
    PriceForm
  },
  data() {
    return {
      model: this.product
    };
  },
  props: {
    product: {
      type: Object
    },
    catalogId: {
      type: Number
    },
    assembled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currencies: function() {
      return this.$store.getters["currencies/currencies"];
    },
    prices: function() {
      return this.model.prices.filter(price => price.catalog_id == this.catalogId);
    }
  },
  methods: {
    getPriceObject(currency) {
      let price = null;
      if (this.assembled) {
        price = this.model.prices.find(
          p =>
            p.catalog_id == this.catalogId &&
            p.currency == currency.currency &&
            p.type == "assembled"
        );
      } else {
        price = this.model.prices.find(
          p =>
            p.catalog_id == this.catalogId &&
            p.currency == currency.currency &&
            p.type != "assembled"
        );
      }

      return price;
    },
    getPrice(currency) {
      if (this.getPriceObject(currency)) {
        return this.getPriceObject(currency).price;
      }
      return 0;
    },
    getType(currency) {
      if (this.assembled) return "assembled";
      if (this.getPriceObject(currency)) {
        return this.getPriceObject(currency).type;
      }
      return null;
    }
  }
};
</script>

<style></style>
